var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"fb-root"}}),_vm._v(" "),_c('div',{staticClass:"fb-page",attrs:{"data-href":_vm.facebookPage,"data-width":"380","data-hide-cover":"false","data-show-facepile":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }